const { countCharacters } = require('./adText/utf8.js');
const adText = require('./adText/adText.js');
const { isSameAdId } = require('./ads');
const locale = require('./locale');
const audience = require('./audience');
const mobileAppSearch = require('./mobileAppSearch');
const editableDashboard = require('./editableDashboard');
const editableElement = require('./dashboard/editableElement');
const dashboardHelpers = require('./dashboard/dashboardHelpers');
const AdAccountArchitecture = require('./dashboard/architecture/AdAccountArchitecture');
const metricUtils = require('./dashboard/utils/metricUtils');
const proposalBudget = require('./proposalBudget');
const { DashboardQueryClient } = require('./dashboard/dashboardQueryClient');
const { DashboardClient, workerList } = require('./dashboard/dashboardClient');
const widgetUtils = require('./dashboardView/widgetUtils');
const predefinedViews = require('./dashboardView/predefinedViews');
const commonConstants = require('./dashboard/constants');
const exporter = require('./dashboard/export');
const customMetric = require('./dashboard/customMetric');
const dashboardFilter = require('./dashboard/dashboardFilter');
const dataSourceUtils = require('./dashboard/utils/dataSourceUtils');
const { getTableDashboardFilterToDataSourceQueryWhereConditions } = require('./dashboard/convertFormat');
const {
  convertLayoutFromDashboardToReportMode,
  convertLayoutFromReportModeToDashboardMode,
  checkAddingNewWidgetToReportLayout,
  hasSpaceForAnWidget,
  convertLayoutFromReportModeToDashboardModeTetris,
} = require('./dashboard/reportMode');

const convertBeFeFormat = require('./dashboard/utils/convertBeFeFormat.js');

module.exports = {
  countCharacters,
  convertTextFromFacebookToGoogle: adText.convertTextFromFacebookToGoogle,
  adText,
  isSameAdId,
  locale,
  audience,
  mobileAppSearch,
  editableDashboard,
  dashboardHelpers,
  AdAccountArchitecture,
  editableElement,
  metricUtils,
  proposalBudget,
  DashboardClient,
  DashboardQueryClient,
  widgetUtils,
  predefinedViews,
  commonConstants,
  exporter,
  customMetric,
  dashboardFilter,
  workerList,
  convertLayoutFromDashboardToReportMode,
  convertLayoutFromReportModeToDashboardMode,
  checkAddingNewWidgetToReportLayout,
  hasSpaceForAnWidget,
  convertLayoutFromReportModeToDashboardModeTetris,
  getTableDashboardFilterToDataSourceQueryWhereConditions,
  dataSourceUtils,
  convertBeFeFormat,
};
